import TheoLogo from '../TheoLogo.jsx';

/* StageTheo — Theo's product world.
   Left column: positioning. Right column: a chat-panel mockup
   that shows Theo handling a structured-output request with
   tool-use, in a way that's representative across surfaces
   (no industry-specific scenarios). */
export default function StageTheo() {
  return (
    <div
      style={{
        padding: '60px',
        height: '100%',
        minHeight: 700,
        background:
          'radial-gradient(60% 60% at 80% 0%, rgba(241,91,255,0.18), transparent 60%), radial-gradient(50% 60% at 0% 100%, rgba(32,214,232,0.15), transparent 60%), #0a0d1f',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 60,
        alignItems: 'center',
      }}
    >
      <div>
        <div style={{ fontFamily: "'JetBrains Mono'", fontSize: 11, letterSpacing: '0.18em', textTransform: 'uppercase', color: 'var(--theo-a)', marginBottom: 24 }}>
          ◇ Theo · AI engine
        </div>
        <TheoLogo height={120} style={{ marginBottom: 24 }} />
        <div style={{ fontFamily: "'Instrument Serif'", fontStyle: 'italic', fontSize: 36, color: 'var(--ink)', letterSpacing: '-0.01em', marginBottom: 24 }}>
          The engine underneath everything.
        </div>
        <p style={{ color: 'var(--ink-mute)', fontSize: 15, lineHeight: 1.6, maxWidth: 460, marginBottom: 28 }}>
          Theo classifies intent, picks the right model, plans
          the steps, and executes — returning structured output
          you can ship straight into the next surface in your
          product. Reasoning, generation, and execution from a
          single engine.
        </p>
        <div style={{ display: 'flex', gap: 24, paddingTop: 24, borderTop: '1px solid var(--line)' }}>
          <div><div style={{ fontFamily: "'Inter Tight'", fontSize: 24, fontWeight: 500 }}>Reason</div><div style={{ color: 'var(--ink-mute)', fontSize: 12 }}>intent + plan</div></div>
          <div><div style={{ fontFamily: "'Inter Tight'", fontSize: 24, fontWeight: 500 }}>Generate</div><div style={{ color: 'var(--ink-mute)', fontSize: 12 }}>structured output</div></div>
          <div><div style={{ fontFamily: "'Inter Tight'", fontSize: 24, fontWeight: 500 }}>Execute</div><div style={{ color: 'var(--ink-mute)', fontSize: 12 }}>tool-use + handoff</div></div>
        </div>
      </div>
      {/* Chat panel */}
      <div
        style={{
          background: 'rgba(15,21,48,0.55)',
          border: '1px solid rgba(255,255,255,0.08)',
          borderRadius: 24,
          backdropFilter: 'blur(10px)',
          padding: 24,
          display: 'flex',
          flexDirection: 'column',
          gap: 14,
          minHeight: 500,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, paddingBottom: 14, borderBottom: '1px solid var(--line)' }}>
          <div style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--theo-a)', boxShadow: '0 0 8px var(--theo-a)' }} />
          <div style={{ fontSize: 13, fontWeight: 500 }}>theo · v3.4</div>
          <div style={{ marginLeft: 'auto', fontSize: 11, color: 'var(--ink-dim)', fontFamily: "'JetBrains Mono'" }}>session_8a3f</div>
        </div>
        <div style={{ padding: '12px 14px', background: 'rgba(255,255,255,0.04)', borderRadius: 14, fontSize: 14, alignSelf: 'flex-end', maxWidth: '85%' }}>
          Build a flowchart for a 3-step onboarding and turn it into a deck.
        </div>
        <div
          style={{
            padding: '14px 16px',
            background: 'linear-gradient(135deg, rgba(32,214,232,0.08), rgba(241,91,255,0.08))',
            borderRadius: 14,
            fontSize: 14,
            lineHeight: 1.55,
            maxWidth: '95%',
            border: '1px solid rgba(255,255,255,0.06)',
          }}
        >
          <span style={{ color: 'var(--theo-a)', fontFamily: "'JetBrains Mono'", fontSize: 12 }}>◇ theo</span><br />
          Generated a <strong style={{ color: 'var(--charts)' }}>3-node onboarding flow</strong> on a new OpenCharts canvas: <em>welcome → connect data → first action</em>. Each node is mapped to a slide. Deck is ready to present, edit, or export.
        </div>
        <div
          style={{
            padding: '14px 16px',
            background: 'rgba(255,255,255,0.03)',
            borderRadius: 14,
            maxWidth: '95%',
            border: '1px solid var(--line)',
            fontFamily: "'JetBrains Mono'",
            color: 'var(--ink-mute)',
            fontSize: 12,
          }}
        >
          <div style={{ color: 'var(--theo-c)', marginBottom: 6 }}>↳ tools</div>
          • opencharts.canvas.create(kind="flow")<br />
          • opencharts.nodes.add(["welcome","connect","first action"])<br />
          • opencharts.deck.from_canvas()
        </div>
        <div style={{ marginTop: 'auto', display: 'flex', alignItems: 'center', gap: 10, padding: '12px 14px', background: 'rgba(255,255,255,0.04)', borderRadius: 14, border: '1px solid var(--line)' }}>
          <span style={{ color: 'var(--theo-a)' }}>◇</span>
          <span style={{ flex: 1, color: 'var(--ink-dim)', fontSize: 13 }}>Ask anything…</span>
          <span style={{ padding: '4px 8px', borderRadius: 6, background: 'rgba(255,255,255,0.06)', fontSize: 10, fontFamily: "'JetBrains Mono'", color: 'var(--ink-mute)' }}>⌘K</span>
        </div>
      </div>
    </div>
  );
}
